/* eslint-disable react/forbid-prop-types */
/* eslint-disable camelcase */
import { deconstructDoc } from 'helpers/deconstructDoc';
import Image from 'next/image';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import styles from './styles';
import { renderPngIcon } from 'helpers/specifications';

const featureList = [
  {
    groupType: 'graphics_card',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-gpu.png?v=1714038721',
  },
  {
    groupType: 'cpu',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-cpu_1.png?v=1714038645',
  },
  {
    groupType: 'ram',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-ram.png?v=1714038794',
  },
  {
    groupType: 'primary_ssd',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-ssd.png?v=1714038814',
  },
  {
    groupType: 'cpu_cooling_system',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-cooling_1.png?v=1714038855',
  },
  {
    groupType: 'cpu_cooling system',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-cooling_1.png?v=1714038855',
  },
  {
    groupType: 'motherboard',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-motherboard.png?v=1714038909',
  },
  {
    groupType: 'display',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-display.webp?v=1714038946',
  },

  {
    groupType: 'airflow',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/airflow.png?v=1714038998',
  },
  {
    groupType: 'chassis',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/chassis.png?v=1714038998',
  },
  {
    groupType: 'color',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/color.png?v=1714038998',
  },
  {
    groupType: 'dimension',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/dimension.png?v=1714038998',
  },
  {
    groupType: 'glass_design',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/glass_design.png?v=1714038998',
  },
  {
    groupType: 'power',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/power.png?v=1714038998',
  },
  {
    groupType: 'screen',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/screen.png?v=1714038998',
  },
  {
    groupType: 'weight',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/weight.png?v=1714038998',
  },
  {
    groupType: 'special_usp',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/special_usp.png?v=1714038998',
  },
  {
    groupType: 'operating_system',
    image:
      'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/Operating-System.png?v=1714052047',
  },
];

const Models = ({ title, pcModels, modelsCardListData, primaryFontColor }) => {
  // console.log("pcModels", pcModels);
  const totalPriceRef = useRef(0);
  const comparePriceRef = useRef(0);
  const [modelIndex, setModelIndex] = useState(0);
  const getFeatureImageByType = (type) => {
    return featureList.find((item) => item.groupType === type)?.image;
  };

  return (
    <>
      <div
        className='configure_columns_slice'
        style={{ backgroundColor: 'inherit' }}
      >
        <div className='configure_columns_container'>
          <div className='title'>
            <h1 style={{ color: primaryFontColor }}>
              {RichText.asText(title)}
            </h1>
          </div>
        </div>

        {pcModels.length > 1 && (
          <div className='mobile_container'>
            {modelsCardListData[modelIndex].isShowingUniqueList && (
              <div className='select_chassis'>Select Your Chassis</div>
            )}
            <div className='models_container'>
              {pcModels.length > 0 &&
                pcModels.map((pcModel, index) => {
                  const handleSelection = () => setModelIndex(index);
                  const rtsModel = pcModel?.rtsModel;
                  if (rtsModel) {
                    return (
                      <button
                        type='button'
                        className={`model_option ${
                          index === modelIndex ? 'active' : ''
                        } ${index}`}
                        key={pcModel?.model_id}
                        onClick={handleSelection}
                      >
                        {rtsModel.title.split('/')[0]}
                      </button>
                    );
                  } else {
                    return (
                      pcModel !== null && (
                        <button
                          type='button'
                          className={`model_option ${
                            index === modelIndex ? 'active' : ''
                          } ${index}`}
                          key={pcModel?.model_id}
                          onClick={handleSelection}
                        >
                          {pcModel?.model_title}
                        </button>
                      )
                    );
                  }
                })}
            </div>
          </div>
        )}
        <div className={`information_container mobile${modelIndex}`}>
          {pcModels.map((pcModel, idx) => {
            const rtsModel = pcModel?.rtsModel;

            const rtsTitle = rtsModel?.title.split('/')[0];
            const rtsSubtitle = rtsModel?.title.split('/')[1];
            const rtsPrice = rtsModel?.variants[0]?.price;
            const rtsCompareAt = rtsModel?.variants[0]?.compare_at_price;

            const rtsSpecifications = rtsModel?.tags
              .split(', ')
              .filter((tag) => tag.includes('specification'))
              .map((tag) => {
                if (
                  tag.split(':')[2].toLowerCase().replace('-', '_') ===
                  'storage'
                ) {
                  return {
                    type: 'primary_ssd',
                    title: tag.split(':')[3],
                  };
                } else if (
                  tag.split(':')[2].toLowerCase().replace('-', '_') ===
                  'dimensions'
                ) {
                  return {
                    type: 'dimension',
                    title: tag.split(':')[3],
                  };
                }
                return {
                  type: tag.split(':')[2].toLowerCase().replace('-', '_'),
                  title: tag.split(':')[3],
                };
              });

            const customLink = pcModel?.customLink;
            const customImage = pcModel?.customImage;

            // console.log('rtsModel', rtsModel);
            // console.log('rtsSpecifications', rtsSpecifications);

            const { seo_description, price, compare_at, slug } = pcModel;
            const modelTitle = pcModel?.pc_model_title || pcModel?.model_title;
            const seoTitle = pcModel?.pc_model_subtitle || pcModel?.seo_title;
            let savedMoney = compare_at - price;

            let paramsString = '';
            if (pcModel.custom_build_pc_url) {
              paramsString = `?${pcModel.custom_build_pc_url.split('?')[1]}`;
            }
            const slugOnBuild = `${slug}${paramsString}`;

            const { options } = deconstructDoc(pcModel);

            let selectionsObject;
            if (pcModel.custom_build_pc_url) {
              const paramsString = pcModel.custom_build_pc_url.split('?')[1];
              const selectionsParam = new URLSearchParams(paramsString).get(
                'selections',
              );
              const decodedString = decodeURIComponent(selectionsParam);
              selectionsObject = JSON.parse(decodedString);
            }

            // based from the selectionsObject
            let filteredOptions;
            if (selectionsObject) {
              const selectedOptions = Object.entries(selectionsObject);
              filteredOptions = options.filter((option) => {
                return selectedOptions.some(
                  ([group_type, variant_id]) =>
                    option.group_type.toLowerCase() ===
                      group_type.toLowerCase() &&
                    option.variant_id === variant_id,
                );
              });
              const priceSelectedOptions = filteredOptions.reduce(
                (acc, cur) => acc + cur.price,
                0,
              );
              const CompareAtSelectedOptions = filteredOptions.reduce(
                (acc, cur) =>
                  acc + (cur.compare_at > 0 ? cur.compare_at : cur.price),
                0,
              );
              totalPriceRef.current =
                filteredOptions[0]?.o_price + priceSelectedOptions;
              comparePriceRef.current = compare_at + CompareAtSelectedOptions;
              savedMoney = comparePriceRef.current - totalPriceRef.current;
            }

            const baseOptions = options?.filter((option) => option.is_base);
            const uniqueInfoData = modelsCardListData[idx];
            if (rtsModel) {
              return (
                <div className='column_information' key={idx}>
                  <div className='column_title'>
                    <h1>{rtsTitle}</h1>
                    <p className='subtitle'>{rtsSubtitle}</p>
                  </div>

                  <div className='information_block_container'>
                    <div
                      className='config_card_image_container'
                      onClick={() =>
                        (window.location.href = customLink
                          ? customLink
                          : `/products/${rtsModel.handle}`)
                      }
                    >
                      {rtsModel.image.src && (
                        <img
                          draggable='false'
                          className='config_card_thumbnail_image'
                          src={customImage ? customImage : rtsModel.image.src}
                          alt={rtsModel.title}
                        />
                      )}
                    </div>
                    {/* Leave this block in case we need to add the rts specifications */}
                    {rtsSpecifications && (
                      <div className='information_block'>
                        {rtsSpecifications.map((feature) => {
                          let imagePath = null;
                          if (feature.type !== 'None') {
                            const tempType = feature.type?.replace(' ', '_');
                            imagePath = getFeatureImageByType(
                              tempType.toLowerCase(),
                            );
                          }
                          return (
                            <div
                              className='description_container'
                              key={feature.type}
                            >
                              <div className='image_icon'>
                                <Image
                                  draggable={false}
                                  src={imagePath}
                                  width={feature.type === 'storage' ? 16 : 20}
                                  height={20}
                                  alt='image_icon'
                                />
                              </div>
                              <div className='description'>
                                <p>{feature.title}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {/* {uniqueInfoData?.isShowingUniqueList === true ? (
                      <div className='information_block'>
                        {uniqueInfoData?.uniqueInfoList?.map((item, idx) => {
                          const type = item?.feature_type;
                          let imagePath = null;
                          if (type !== 'None') {
                            const tempType = type?.replace(' ', '_');
                            imagePath = getFeatureImageByType(
                              tempType.toLowerCase(),
                            );
                          }
                          return (
                            <div className='description_container' key={idx}>
                              {type !== 'None' ? (
                                <div className='image_icon'>
                                  {imagePath && (
                                    <Image
                                      draggable={false}
                                      src={imagePath}
                                      width={20}
                                      height={20}
                                      alt='image_icon'
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className='red_dot' />
                              )}
                              <div className='description'>
                                <p>{item.unique_info}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className='information_block'>
                        {featureList.map((feature) => {
                          let featuredOption;
                          if (filteredOptions) {
                            featuredOption = filteredOptions.find(
                              (option) =>
                                option.group_type === feature.groupType,
                            );
                            if (!featuredOption) {
                              featuredOption = baseOptions.find(
                                (option) =>
                                  option.group_type === feature.groupType,
                              );
                            }
                          } else {
                            featuredOption = baseOptions.find(
                              (option) =>
                                option.group_type === feature.groupType,
                            );
                          }
                          return featuredOption ? (
                            <div
                              className='description_container'
                              key={feature.groupType}
                            >
                              <div className='image_icon'>
                                <Image
                                  draggable={false}
                                  src={feature.image}
                                  width={20}
                                  height={20}
                                  alt='image_icon'
                                />
                              </div>
                              <div className='description'>
                                <p>{featuredOption.title}</p>
                              </div>
                            </div>
                          ) : (
                            ''
                          );
                        })}
                      </div>
                    )} */}
                  </div>
                  <div className='bottom_container'>
                    <div className='price_information_container'>
                      <p className='currency'>From SGD</p>
                      <div className='price_compare_container'>
                        <del>
                          <p className='compare_price'>
                            ${parseFloat(rtsCompareAt).toLocaleString()}
                          </p>
                        </del>
                        <p className='price'>
                          {parseFloat(rtsPrice).toLocaleString()}
                        </p>
                      </div>
                      {parseFloat(rtsCompareAt) - parseFloat(rtsPrice) > 0 && (
                        <p className='saved_money'>
                          You save $
                          {(
                            parseFloat(rtsCompareAt) - parseFloat(rtsPrice)
                          ).toLocaleString()}{' '}
                          SGD
                        </p>
                      )}
                    </div>

                    <Link href={customLink ? customLink : `/products/${rtsModel.handle}`}>
                      <a
                        href={customLink ? customLink : `/products/${rtsModel.handle}`}
                        className='customise'
                        style={{
                          backgroundColor: primaryFontColor
                            ? primaryFontColor
                            : '#950810',
                        }}
                      >
                        Buy Now
                      </a>
                    </Link>
                  </div>
                </div>
              );
            } else {
              return (
                <div className='column_information' key={idx}>
                  <div className='column_title'>
                    <h1>{modelTitle}</h1>
                    <p className='subtitle'>{seoTitle}</p>
                  </div>

                  <div className='information_block_container'>
                    {/* {uniqueInfoData?.isShowingThumbnailImage ||
                    uniqueInfoData?.isShowingUniqueList ? ( */}
                    <div
                      className='config_card_image_container'
                      onClick={() =>
                        (window.location.href = customLink ? customLink : `/pc-models/${slugOnBuild}`)
                      }
                    >
                      {pcModel.thumb_image && (
                        <img
                          draggable='false'
                          className='config_card_thumbnail_image'
                          src={customImage ? customImage : pcModel.thumb_image}
                          alt={modelTitle}
                        />
                      )}
                    </div>
                    {/* ) : (
                      <p className='summary'>{seo_description}</p>
                    )} */}

                    {uniqueInfoData?.isShowingUniqueList === true ? (
                      <div className='information_block'>
                        {uniqueInfoData?.uniqueInfoList?.map((item, idx) => {
                          const type = item?.feature_type;
                          let imagePath = null;
                          if (type !== 'None') {
                            const tempType = type?.replace(' ', '_');
                            imagePath = getFeatureImageByType(
                              tempType.toLowerCase(),
                            );
                          }
                          return (
                            <div className='description_container' key={idx}>
                              {type !== 'None' ? (
                                <div className='image_icon'>
                                  {imagePath && (
                                    <Image
                                      draggable={false}
                                      src={imagePath}
                                      width={20}
                                      height={20}
                                      alt='image_icon'
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className='red_dot' />
                              )}
                              <div className='description'>
                                <p>{item.unique_info}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className='information_block'>
                        {featureList.map((feature) => {
                          let featuredOption;
                          if (filteredOptions) {
                            featuredOption = filteredOptions.find(
                              (option) =>
                                option.group_type === feature.groupType,
                            );
                            if (!featuredOption) {
                              featuredOption = baseOptions.find(
                                (option) =>
                                  option.group_type === feature.groupType,
                              );
                            }
                          } else {
                            featuredOption = baseOptions.find(
                              (option) =>
                                option.group_type === feature.groupType,
                            );
                          }
                          return featuredOption ? (
                            <div
                              className='description_container'
                              key={feature.groupType}
                            >
                              <div className='image_icon'>
                                <Image
                                  draggable={false}
                                  src={feature.image}
                                  width={20}
                                  height={20}
                                  alt='image_icon'
                                />
                              </div>
                              <div className='description'>
                                <p>{featuredOption.title}</p>
                              </div>
                            </div>
                          ) : (
                            ''
                          );
                        })}
                      </div>
                    )}
                  </div>
                  <div className='bottom_container'>
                    <div className='price_information_container'>
                      <p className='currency'>From SGD</p>
                      <div className='price_compare_container'>
                        {selectionsObject
                          ? savedMoney > 0 && (
                              <del>
                                <p className='compare_price'>
                                  $
                                  {parseFloat(
                                    comparePriceRef.current,
                                  ).toLocaleString()}
                                </p>
                              </del>
                            )
                          : savedMoney > 0 && (
                              <del>
                                <p className='compare_price'>
                                  ${parseFloat(compare_at).toLocaleString()}
                                </p>
                              </del>
                            )}
                        <p className='price'>
                          {selectionsObject
                            ? `$${parseFloat(
                                totalPriceRef.current,
                              ).toLocaleString()}`
                            : `$${parseFloat(price).toLocaleString()}`}
                        </p>
                      </div>
                      {savedMoney > 0 && (
                        <p className='saved_money'>
                          You save ${parseFloat(savedMoney).toLocaleString()}{' '}
                          SGD
                        </p>
                      )}
                    </div>

                    <Link href={customLink ? customLink : `/pc-models/${slugOnBuild}`}>
                      <a
                        href={customLink ? customLink : `/pc-models/${slugOnBuild}`}
                        className='customise'
                        style={{
                          backgroundColor: primaryFontColor
                            ? primaryFontColor
                            : '#950810',
                        }}
                      >
                        Buy Now
                      </a>
                    </Link>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Models.propTypes = {
  title: PropTypes.any.isRequired,
  pcModels: PropTypes.array.isRequired,
  selectionsObject: PropTypes.any,
};

export default Models;
